import { useCallback } from 'react';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';

import { preserveClassicUiParam } from '../util/classicUi';

export const useClassicNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      navigate(preserveClassicUiParam(to, location.search), options);
    },
    [location.search, navigate]
  );
};
